import service from '@/helpers/serviceGPAO'

export async function listerReclamations(etabId){
    return await service.get('incidentsReclamations/reclamations/' + etabId);
}

export async function traiterReclamation(reclamationId){
    return await service.patch('incidentsReclamations/reclamations/traiter/' + reclamationId);
}